//Case Report Narratives

import { httpDelete, httpGet, httpPatch } from "../connection";

// /:case_id/case-reports/:case_report_id/case-report-narratives
async function getCaseReportNarrative(params: {
  case_id: number;
  case_report_id: number;
  narrative_id?: number;
}) {
  return await httpGet(
    `/cases/${params.case_id}/case-reports/${params.case_report_id}/case-report-narratives`,
    params
  );
}

async function updateCaseReportNarrative(params: {
  case_id: number;
  case_report_id: number;
  narrative_id: number;
}) {
  return await httpPatch(
    `/cases/${params.case_id}/case-reports/${params.case_report_id}/case-report-narratives/${params.narrative_id}`,
    params
  );
}

async function deleteCaseReportNarrative(params: {
  case_id: number;
  case_report_id: number;
  narrative_id: number;
}) {
  return await httpDelete(
    `/cases/${params.case_id}/case-reports/${params.case_report_id}/case-report-narratives/${params.narrative_id}`
  );
}

const CaseReportNarrativesApi = {
  getCaseReportNarrative,
  updateCaseReportNarrative,
  deleteCaseReportNarrative,
};

export default CaseReportNarrativesApi;
